import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
export var IconSystemSocialLinkedin = function IconSystemSocialLinkedin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 40 40"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M37.04 0H2.951C1.324 0 0 1.291 0 2.883v34.23C0 38.708 1.324 40 2.952 40H37.04c1.631 0 2.96-1.293 2.96-2.886V2.883C40 1.291 38.67 0 37.04 0",
    style: {
      fill: 'currentColor',
      fillOpacity: 1,
      fillRule: 'nonzero',
      stroke: 'none'
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.898 5.507a3.441 3.441 0 0 1 0 6.88 3.44 3.44 0 0 1 0-6.88m-2.968 9.49h5.933v19.088H5.93zm9.654 0h5.692v2.608h.078c.792-1.5 2.727-3.083 5.614-3.083 6.007 0 7.117 3.954 7.117 9.093v10.471h-5.93v-9.283c0-2.214-.04-5.062-3.082-5.062-3.087 0-3.56 2.412-3.56 4.902v9.443h-5.929z",
    style: {
      fill: '#fff',
      fillOpacity: 1,
      fillRule: 'nonzero',
      stroke: 'none'
    }
  }));
};